<template>
  <component
    :is="linkComponent"
    v-if="label"
    class="btn-link-color-s"
    v-bind="componentProps"
    data-testid="notification-cta"
    @click="emit('click')"
  >
    {{ label }}
    <ExternalLinkIcon v-if="opensNewTab" class="lucide-icon-xs" aria-hidden="true" />
  </component>
</template>

<script setup lang="ts">
import { ExternalLinkIcon } from '@ramp106/omrjs-core-ui/icons'
import { computed } from 'vue'

import { fieldValue } from './blockHelpers'
import type { NotificationBlock } from './types'

const props = defineProps<{
  block: NotificationBlock
}>()

const emit = defineEmits<{ click: [] }>()

const label = computed(() => fieldValue(props.block, 'label'))
const url = computed(() => fieldValue(props.block, 'url'))
const email = computed(() => fieldValue(props.block, 'email'))
const isExternalLink = computed(() => !!url.value && url.value.startsWith('http'))
const opensNewTab = computed(() => isExternalLink.value || (!url.value && !!email.value))

const linkComponent = computed(() => {
  if (url.value) return isExternalLink.value ? 'a' : 'RouterLink'
  if (email.value) return 'a'
  return 'button'
})

const componentProps = computed(() => {
  if (url.value) return isExternalLink.value ? { href: url.value, target: '_blank', rel: 'noopener noreferrer' } : { to: url.value }
  if (email.value) return { href: `mailto:${email.value}`, target: '_blank', rel: 'noopener noreferrer' }
  return { type: 'button' }
})
</script>
